export const getNewBookingSidebar = ({
  bookingSidebar,
  rooms,
  ratePlans,
  fromdate,
  todate,
  extraBedPrice,
  promoDiscount,
  promoCode,
  totalDays,
}) => {
  const updatedSidebar = bookingSidebar.map((item) => {
    if (item.type === "addonservice") {
      return item; // Add-on services don’t need rate adjustments
    }

    const room = rooms.find((r) => r._id === item.roomId);
    const ratePlan = ratePlans[item.roomId]?.find(
      (rp) => rp.rateplanname === item.ratePlanName
    );

    // Use the pre-calculated totalRate from Room component, which includes promo discount if applicable
    const totalRate = item.totalRate;

    const extraBedTotalPrice = item.extraBed
      ? Object.values(item.extraBed).reduce(
          (sum, isExtraBed) =>
            sum + (isExtraBed ? extraBedPrice * totalDays : 0),
          0
        )
      : 0;

    return {
      ...item,
      roomName: room?.name || "Unknown Room",
      imageurls: room?.imageurls || [],
      mealPlan: ratePlan?.mealPlan || item.mealPlan || "None",
      cancellationPolicy: ratePlan?.cancellationPolicy
        ? `${ratePlan.cancellationPolicy.chargeType} - ${
            ratePlan.cancellationPolicy.chargePercentage
          }% charge ${
            ratePlan.cancellationPolicy.chargeType === "Flexible" &&
            ratePlan.cancellationPolicy.daysBeforeCheckin
              ? `if canceled ${ratePlan.cancellationPolicy.daysBeforeCheckin} days before check-in.`
              : ""
          }`
        : item.cancellationPolicy || "Flexible",
      fromdate,
      todate,
      totalRate, // Pre-calculated rate with promo discount included if applicable
      roomId: room?._id || item.roomId,
      extraBed: item.extraBed || {},
      extraBedTotalPrice,
      promoCode: promoDiscount ? promoCode : null,
      promoDiscount:
        promoDiscount &&
        promoDiscount.applicableRooms.includes(item.roomId) &&
        promoDiscount.applicableRatePlans.includes(item.ratePlanId)
          ? promoDiscount.discountPercentage
          : 0,
    };
  });
  return updatedSidebar;
};
